// Client-side copy of the rules in spark.core.export-date-range. The limits are read from the
// data attributes rendered by spark.views.shared.export-date-range so both sides stay in step.

function dateInputs(container) {
  return {
    startInput: container.querySelector('input[name="start-date"]'),
    endInput: container.querySelector('input[name="end-date"]')
  };
}

function parseDate(value) {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function formatDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

// Matches Joda's plusYears: a leap day start lands on Feb 28 rather than rolling into March
function addYears(date, years) {
  const result = new Date(date.getFullYear() + years, date.getMonth(), date.getDate());
  if (result.getMonth() !== date.getMonth()) {
    result.setDate(0);
  }
  return result;
}

function exclusiveEndDate(startDate, maxRangeYears) {
  return formatDate(addYears(parseDate(startDate), maxRangeYears));
}

export function initExportDateRange(container) {
  const {startInput, endInput} = dateInputs(container);
  const {minDate, maxDate} = container.dataset;
  const maxRangeYears = Number(container.dataset.maxRangeYears);

  const updateEndDateBounds = () => {
    if (!startInput.value) {
      endInput.min = minDate;
      endInput.max = maxDate;
      return;
    }

    const lastEndDate = parseDate(exclusiveEndDate(startInput.value, maxRangeYears));
    lastEndDate.setDate(lastEndDate.getDate() - 1);

    endInput.min = startInput.value;
    endInput.max = [formatDate(lastEndDate), maxDate].sort()[0];
  };

  startInput.addEventListener('change', updateEndDateBounds);
  updateEndDateBounds();
}

// Returns an error message, or null when the range is valid
export function validateExportDateRange(container) {
  const {startInput, endInput} = dateInputs(container);
  const {minDate, maxDate, maxYearsBack, notBeforeMessage} = container.dataset;
  const maxRangeYears = Number(container.dataset.maxRangeYears);
  const startDate = startInput.value;
  const endDate = endInput.value;

  if (!startDate || !endDate) {
    return 'Start date and end date are required';
  }
  if (startDate > endDate) {
    return 'Start date must be on or before the end date';
  }
  if (startDate < minDate) {
    return notBeforeMessage || `Start date must be within the last ${maxYearsBack} years`;
  }
  if (endDate > maxDate) {
    return 'End date cannot be in the future';
  }
  if (endDate >= exclusiveEndDate(startDate, maxRangeYears)) {
    return `Date range cannot be longer than ${maxRangeYears} year`;
  }
  return null;
}
